import { Outlet } from 'react-router-dom';

function Cobranza() {
  return <Outlet />;
}

export default Cobranza;
